import { Radio } from "antd";
import React, { useContext } from "react";
import GlobalStoreContext from "../../../context/GlobalStoreContext";
import Modal from "../../UI/Modal";
import IntegrationIcon from "../integrationIcon";
import { IntegrationName } from "../integrationName";
import AddIntegrationVendorsToProject from "./integration/addIntegrationVendorsToProject";
import AddManual from "./manual/addManual";

interface Props {
    visible: boolean;
    onClose: () => void;
    onSelect: (team_id: number) => void;
    vendorMode?: boolean;
}

// This modal is used to add a team to a jobsite, either manually or through integration.
// On the manual side, this modal can add teams as a trade or as a vendor (vendorMode).
// This modal can also be used through url params in order to add a team/user to the jobsite
// that a user requested to join.
const AddTeamToProjectModal: React.FC<Props> = (props) => {
    const context = useContext(GlobalStoreContext);

    const [selectedCreateMode, setSelectedCreateMode] = React.useState<"MANUAL" | "INTEGRATION">("MANUAL");

    return (
        <Modal
            title={props.vendorMode ? "Add Vendor to Jobsite" : "Add Trade Contractor to Jobsite"}
            open={props.visible}
            onClose={props.onClose}
            onCancel={props.onClose}
            destroyOnHidden={true}
            width={"66%"}
        >
            <Radio.Group
                className="w-full flex! items-center"
                value={selectedCreateMode}
                onChange={(e) => setSelectedCreateMode(e.target.value as "MANUAL" | "INTEGRATION")}
            >
                <Radio.Button className={"w-1/2"} value={"MANUAL"}>
                    Add Manually
                </Radio.Button>
                <Radio.Button className={"w-1/2"} value={"INTEGRATION"}>
                    <div className="flex flex-row items-center">
                        Import from
                        <IntegrationIcon
                            project={context.currentProjectInfo}
                            className="w-3! h-3! ml-2 mr-1"
                            activated={true}
                        />
                        <IntegrationName project={context.currentProjectInfo} />
                    </div>
                </Radio.Button>
            </Radio.Group>
            <div className="mt-4" />

            {selectedCreateMode == "MANUAL" && (
                <AddManual
                    vendorMode={props.vendorMode}
                    visible={props.visible}
                    onCancel={props.onClose}
                    onSelect={props.onSelect}
                />
            )}
            {selectedCreateMode == "INTEGRATION" && (
                <AddIntegrationVendorsToProject onClose={props.onClose} vendorMode={props.vendorMode} />
            )}
        </Modal>
    );
};

export default AddTeamToProjectModal;
